import { Inject, Injector, Component } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SgClickConfirmDialogContainerContext {
  component: any;
  injector: Injector;
}

@Component({
  selector: 'sg-click-confirm-dialog-container',
  template: `<ng-container *ngComponentOutlet="data.component; injector: data.injector"></ng-container>`,
  standalone: false,
})
export class SgClickConfirmDialogContainer {
  constructor(@Inject(MAT_DIALOG_DATA) public data: SgClickConfirmDialogContainerContext) {}
}
